import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

type ThisFieldTemplate = Pick<QuestionnaireApiModels.FieldTemplate, 'listFieldTemplateId' | 'type' | 'id'>;

const DEPTH_LIMIT = 100;
const getAllChildFields = <F extends ThisFieldTemplate>({
  fieldId,
  fieldsById,
}: {
  fieldId: string | undefined;
  fieldsById: Record<string, F>;
}): F[] => {
  const allChildFields: F[] = [];
  const allFields = Object.values(fieldsById);
  const visitedFields = new Set<string>();

  const traverseFields = ({ depth, fieldId: thisFieldId }: { depth: number; fieldId: string | undefined; }): void => {
    if (!thisFieldId || depth === DEPTH_LIMIT || visitedFields.has(thisFieldId)) {
      return;
    }

    const currentField = fieldsById[thisFieldId];
    if (!currentField) {
      return;
    }

    visitedFields.add(currentField.id);
    allChildFields.push(currentField);

    if (['list', 'table', 'explanation'].includes(currentField?.type)) {
      allFields
        .filter(child => child.listFieldTemplateId === currentField.id)
        .forEach(child => traverseFields({
          depth: depth + 1,
          fieldId: child.id,
        }));
    }
  };

  traverseFields({ depth: 0, fieldId });
  return allChildFields;
};

export default getAllChildFields;
